import { type ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

type HelmetProps = Parameters<Helmet['shouldComponentUpdate']>[0];

type PageTitleProps = HelmetProps & {
  readonly children: ReactNode;
};
export const PageTitle = ({ children, ...helmetProps }: PageTitleProps) => {
  return <Helmet {...helmetProps}>{children}</Helmet>;
};
